import moment from 'moment';
import { VoucherKycModel } from './VoucherKycModel';
export class VoucherRebateModel {
    constructor(payload) {
        Object.assign(this, payload);
        const { voucherKyc } = payload;
        if (voucherKyc) {
            this.voucherKyc = new VoucherKycModel(voucherKyc);
        }
    }
    get submissionDate() {
        const createdAt = new Date(this.rebate.createdAt);
        return moment(createdAt).format('LLL');
    }
    get customerFullName() {
        if (this.rebate.customerDetail) {
            const { firstName, lastName } = this.rebate.customerDetail;
            return `${firstName} ${lastName}`;
        }
        return '';
    }
    get dateApproved() {
        if (this.rebate.approvedAt) {
            const approvedAt = new Date(this.rebate.approvedAt);
            return moment(approvedAt).format('LLL');
        }
        return '';
    }
    get fullAddress() {
        if (this.rebate.customerDetail) {
            const { country, region, city, street, building, room, zipCode } = this.rebate.customerDetail;
            return `${country}, ${region}, ${city}, ${street}, ${building} ${room} ${zipCode}`;
        }
        return '';
    }
    get dateRedeemed() {
        if (this.usedAt) {
            const usedAt = new Date(this.usedAt);
            return moment(usedAt).format('LLL');
        }
        return '';
    }
    get orderFullName() {
        if (this.order) {
            const { firstName, lastName } = this.order;
            return `${firstName} ${lastName}`;
        }
        return '';
    }
}
